import PassengerType from './PassengerType';

export default PassengerType;
